svg{width:305px;height:165px}
/*# sourceMappingURL=stopwatch.component-427CHZA2.css.map */
